import * as React from 'react';
import { DataConsumerType } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import { Form, FormField, Select } from '@amzn/awsui-components-react-v3';
import { OptionDefinition } from '@amzn/awsui-components-react-v3/polaris/internal/components/option/interfaces';

export interface DataConsumerTypeSelectorProps {
  dataConsumerType: DataConsumerType;
  setDataConsumerType: (value: DataConsumerType) => void;
}

export const DataConsumerTypeSelector = (props: DataConsumerTypeSelectorProps) => {
  const dropdownOptions: OptionDefinition[] = [
    {
      label: 'Data consumer',
      description: 'A data consumer accesses and queries the data.',
      value: 'DataConsumer',
    },
    {
      label: 'Data custodian',
      description: 'A data custodian is a data consumer who also transforms, stores, or re-publishes the data.',
      value: 'DataCustodian',
    },
  ];

  const selectedOption = () => {
    return dropdownOptions.filter((option) => option.value == props.dataConsumerType).pop();
  };

  const setSelectedOption = (option: OptionDefinition) => {
    props.setDataConsumerType(option.value);
  };

  return (
    <Form>
      <FormField
        label={'Data consumer type'}
        description={'Select the option that best describes your role in using this data.'}
      >
        <Select
          options={dropdownOptions}
          selectedOption={selectedOption()}
          onChange={(e) => setSelectedOption(e.detail.selectedOption)}
        />
      </FormField>
    </Form>
  );
};
